import React from "react"

const Exit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        d="M17.6776 16.499L15.3206 14.142L17.6776 11.785C17.8339 11.6287 17.9217 11.4168 17.9217 11.1957C17.9217 10.9747 17.8339 10.7628 17.6776 10.6065C17.5213 10.4502 17.3094 10.3624 17.0884 10.3624C16.8674 10.3624 16.6554 10.4502 16.4991 10.6065L14.1421 12.9635L11.7851 10.6065C11.6288 10.4502 11.4168 10.3624 11.1958 10.3624C10.9748 10.3624 10.7628 10.4502 10.6066 10.6065C10.4503 10.7628 10.3625 10.9747 10.3625 11.1957C10.3625 11.4168 10.4503 11.6287 10.6066 11.785L12.9636 14.142L10.6066 16.499C10.4503 16.6553 10.3625 16.8673 10.3625 17.0883C10.3625 17.3093 10.4503 17.5213 10.6066 17.6776C10.7628 17.8338 10.9748 17.9216 11.1958 17.9216C11.4168 17.9216 11.6288 17.8338 11.7851 17.6776L14.1421 15.3205L16.4991 17.6776C16.6554 17.8338 16.8674 17.9216 17.0884 17.9216C17.3094 17.9216 17.5213 17.8338 17.6776 17.6776C17.8339 17.5213 17.9217 17.3093 17.9217 17.0883C17.9217 16.8673 17.8339 16.6553 17.6776 16.499Z"
        fill="#1F1F23"
      />
    </svg>
  )
}

export default Exit
